export { applyFilterToolCallInput } from '@/utils/applyFilterToolCallInput';

/** Returns a copy of `input` without the four fields a metric filter mapping owns. */
export const withoutMappingOwnedFields = ({
  eventFilterGroups: _eventFilterGroups,
  pitchStartZones: _pitchStartZones,
  pitchEndZones: _pitchEndZones,
  positions: _positions,
  ...rest
}: Record<string, unknown>): Record<string, unknown> => rest;

const isPropertiesRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/**
 * Returns `schema` unchanged when `metrics` is empty; otherwise a shallow copy whose
 * `properties` gains a `metricKey` field with an enum of selectable metric keys.
 */
export const withMetricKeyField = (
  schema: Record<string, unknown>,
  metrics: { key: string; label: string }[],
): Record<string, unknown> => {
  if (metrics.length === 0 || !isPropertiesRecord(schema.properties)) return schema;

  const pairs = metrics.map(({ key, label }) => `${key} = ${label}`).join('; ');
  const description =
    `Select a metric to show its events on the pitch (the other filters are then set from that metric). ` +
    `Use it when the user asks for a metric by key or by name. Available metrics: ${pairs}.`;

  return {
    ...schema,
    properties: {
      ...schema.properties,
      metricKey: {
        type: 'string',
        enum: metrics.map(({ key }) => key),
        description,
      },
    },
  };
};
